import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import { I18nProvider } from "@/lib/i18n";
import AgeGate from "@/components/AgeGate";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";
import GoldSparkles from "@/components/GoldSparkles";

import Home from "@/pages/Home";
import Companions from "@/pages/Companions";
import CompanionDetail from "@/pages/CompanionDetail";
import Services from "@/pages/Services";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Blog from "@/pages/Blog";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <AgeGate />}
      {!isAdmin && <GoldSparkles density={42} />}
      <Navbar />
      <ScrollToTop />
      <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/companions" element={<Companions />} />
          <Route path="/companions/:id" element={<CompanionDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingContact />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
